import React, { ReactElement, useState, useEffect } from "react";
import PlotlyChart from "react-plotlyjs-ts";

import {
  WeibullProps,
  LinearRegressionProps,
  getWeibullScale,
} from "../../utils/utils";

interface Props {
  wb: WeibullProps[];
  lg: LinearRegressionProps[];
  yValue: string | null;
  failureCriterion: number;
  intersections: string;
}

function WeibullPlot({
  wb,
  lg,
  yValue,
  failureCriterion,
  intersections,
}: Props): ReactElement {
  const [height, setHeight] = useState(window.innerHeight - 270);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight - 270);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  });

  return (
    <div
      style={{ border: "solid 1px", borderRadius: "5px", marginBottom: "10px" }}
    >
      <PlotlyChart
        data={[
          ...wb.map((e: any) => {
            return {
              ...e,
              type: "scatter",
              mode: "markers",
              text: e.f.map((elm: number) => `${(100 * elm).toFixed(2)}%`),
              hovertemplate: `y: %{text} + <br>x: %{x}`,
            };
          }),
          ...lg.map((e: any) => {
            return {
              ...e,
              hoverinfo: "none",
              name: "",
              marker: {
                size: 1,
              },
            };
          }),
        ]}
        layout={{
          title: `Zyklus @ ${failureCriterion}% ${yValue}`,
          // showlegend: false,
          height: height,
          legend: { orientation: "h", side: "bottom" },
          paper_bgcolor: "#eee",
          yaxis: {
            tickmode: "array",
            ...getWeibullScale(),
          },
          margin: {
            t: 40,
            l: 40,
            r: 40,
            b: 40,
          },
          annotations: [
            {
              x: 0.1,
              y: 0.8,
              xref: "paper",
              yref: "paper",
              text: "<b>x-axis intersections</b><br>" + intersections,
              showarrow: false,
              font: {
                family: "Oswald",
                size: 14,
                color: "black",
              },
              align: "center",
              bordercolor: "#c7c7c7",
              borderwidth: 1,
              borderpad: 4,
              bgcolor: "#c5c4c4",
              opacity: 0.8,
            },
          ],
        }}
      />
    </div>
  );
}

const Memo = React.memo(WeibullPlot, (p, n) => {
  if (JSON.stringify(p.wb) !== JSON.stringify(n.wb)) {
    return false;
  }
  return true;
});

export default Memo;
